import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import Spinner from "react-bootstrap/Spinner";

const CloseButton = ({ onClick }) => (
  <button
    type="button"
    aria-label="Cerrar"
    onClick={onClick}
    className="custom-modal-close"
  >
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="11" r="11" fill="rgba(0,0,0,0.08)"/>
      <path d="M7 7L15 15M15 7L7 15" stroke="#444" strokeWidth="2" strokeLinecap="round"/>
    </svg>
  </button>
);

const ModalConfirmEmail = ({
  show,
  onHide,
  onSubmit,
  onResend,
  emailMasked,
  code,
  setCode,
  loading
}) => (
  <>
    <style>
      {`
        .custom-modal-close {
          position: absolute;
          top: 18px;
          right: 18px;
          background: none;
          border: none;
          padding: 0;
          z-index: 20;
          cursor: pointer;
          border-radius: 50%;
          transition: background 0.2s;
        }
        .custom-modal-close:hover {
          background: rgba(0,0,0,0.10);
        }
        .custom-modal-close svg circle {
          transition: fill 0.2s;
        }
        .dark-mode .custom-modal-close svg path {
          stroke: #fff;
        }
        .dark-mode .custom-modal-close svg circle {
          fill: rgba(255,255,255,0.10);
        }
        .light-mode .custom-modal-close svg path {
          stroke: #444;
        }
        .light-mode .custom-modal-close svg circle {
          fill: rgba(0,0,0,0.08);
        }
        .modal-header .btn-close {
          display: none !important;
        }
        .dark-mode .modal-content {
          background-color: var(--modal-bg, #222) !important;
          color: var(--text-color, #fff) !important;
          border: 1px solid var(--border-color, #444) !important;
        }
        .dark-mode .modal-header, .dark-mode .modal-body {
          background-color: var(--modal-bg, #222) !important;
          color: var(--text-color, #fff) !important;
        }
        .dark-mode .modal-backdrop.show {
          opacity: 0.7 !important;
          background-color: var(--modal-backdrop-color, #111) !important;
        }
        .light-mode .modal-content {
          background-color: var(--modal-bg, #fff) !important;
          color: var(--text-color, #222) !important;
          border: 1px solid var(--border-color, #ced4da) !important;
        }
        .light-mode .modal-header, .light-mode .modal-body {
          background-color: var(--modal-bg, #fff) !important;
          color: var(--text-color, #222) !important;
        }
        .light-mode .modal-backdrop.show {
          opacity: 0.5 !important;
          background-color: var(--modal-backdrop-color, #000) !important;
        }
        .modal-header {
          position: relative;
        }
        .modal-body {
          position: relative;
        }
        .modal-resend-section {
          margin-top: 20px;
          font-size: 0.9rem;
          text-align: center;
          padding: 16px;
          border-radius: 8px;
          border: 1px solid var(--info-border, #ced4da);
        }
        .light-mode .modal-resend-section {
          background-color: var(--info-bg, #f8f9fa);
          color: var(--text-muted, #888);
        }
        .dark-mode .modal-resend-section {
          background-color: var(--info-bg, #18191a);
          color: var(--text-muted, #bbb);
          border: 1px solid var(--info-border, #333);
        }
      `}
    </style>
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header
        style={{
          borderBottom: '1px solid var(--border-color, #ced4da)',
          borderRadius: '12px 12px 0 0',
          position: 'relative',
          minHeight: '3rem'
        }}
      >
        <Modal.Title style={{ fontWeight: 600 }}>
          Verificación de Email
        </Modal.Title>
        <CloseButton onClick={onHide} />
      </Modal.Header>
      <Modal.Body
        style={{
          padding: '2rem',
          borderRadius: '0 0 12px 12px'
        }}
      >
        <div
          style={{
            border: "2px solid var(--border-color, #ced4da)",
            borderRadius: "16px",
            padding: "24px",
            background: "var(--input-bg, #fafbfc)",
            marginBottom: "16px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)"
          }}
        >
          <div style={{
            marginBottom: "20px",
            fontSize: '1rem',
            lineHeight: '1.6'
          }}>
            <p style={{ marginBottom: '12px' }}>
              Hemos enviado un <strong>código de verificación</strong> al correo electrónico registrado para el Acudiente Principal:
            </p>
            <div style={{
              backgroundColor: 'var(--highlight-bg, #e3f2fd)',
              border: '1px solid var(--highlight-border, #2196f3)',
              borderRadius: '8px',
              padding: '12px 16px',
              textAlign: 'center',
              fontWeight: '600',
              color: 'var(--highlight-text, #1976d2)',
              fontSize: '1.1rem'
            }}>
              {emailMasked}
            </div>
          </div>

          <Form.Group style={{ marginBottom: "24px" }}>
            <Form.Label style={{
              fontWeight: '500',
              marginBottom: '8px',
              fontSize: '0.95rem'
            }}>
              Código de verificación:
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Ingrese el código de 6 dígitos"
              value={code}
              onChange={e => setCode(e.target.value)}
              autoFocus
              style={{
                fontSize: '1.1rem',
                padding: '12px 16px',
                borderRadius: '8px',
                border: '2px solid var(--border-color, #ced4da)',
                backgroundColor: 'var(--input-bg, #fff)',
                color: 'var(--text-color, #222)',
                textAlign: 'center',
                letterSpacing: '2px',
                fontWeight: '600'
              }}
              maxLength={6}
            />
          </Form.Group>

          <div style={{
            display: 'flex',
            gap: '12px',
            marginBottom: "20px"
          }}>
            <Button
              variant="primary"
              onClick={onSubmit}
              disabled={loading || !code || code.length < 6}
              style={{
                flex: 1,
                padding: '12px 24px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '1rem',
                backgroundColor: 'var(--primary-color, #1976d2)',
                border: 'none',
                boxShadow: '0 2px 8px rgba(25, 118, 210, 0.3)',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                if (!loading && code && code.length >= 6) {
                  e.target.style.backgroundColor = 'var(--primary-hover, #1565c0)';
                  e.target.style.transform = 'translateY(-1px)';
                  e.target.style.boxShadow = '0 4px 12px rgba(25, 118, 210, 0.4)';
                }
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'var(--primary-color, #1976d2)';
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = '0 2px 8px rgba(25, 118, 210, 0.3)';
              }}
            >
              {loading ? (
                <>
                  <Spinner
                    animation="border"
                    size="sm"
                    style={{ marginRight: '8px' }}
                  />
                  Verificando...
                </>
              ) : (
                'Verificar Código'
              )}
            </Button>

            <Button
              variant="outline-secondary"
              onClick={onHide}
              disabled={loading}
              style={{
                padding: '12px 24px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '1rem',
                border: '2px solid var(--border-color, #888)',
                color: 'var(--text-color, #222)',
                backgroundColor: 'transparent',
                transition: 'all 0.3s ease'
              }}
              onMouseOver={(e) => {
                if (!loading) {
                  e.target.style.backgroundColor = 'var(--border-color, #888)';
                  e.target.style.color = 'white';
                }
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
                e.target.style.color = 'var(--text-color, #222)';
              }}
            >
              Cancelar
            </Button>
          </div>

          <div className="modal-resend-section">
            <div style={{ marginBottom: '8px' }}>
              ¿No recibiste el código?
            </div>
            <button
              onClick={onResend}
              disabled={loading}
              style={{
                background: 'none',
                border: 'none',
                color: 'var(--link-color, #1976d2)',
                textDecoration: 'underline',
                cursor: 'pointer',
                fontWeight: '600',
                fontSize: '0.95rem',
                padding: '4px 8px',
                borderRadius: '4px',
                transition: 'all 0.2s ease'
              }}
              onMouseOver={(e) => {
                if (!loading) {
                  e.target.style.backgroundColor = 'var(--link-hover-bg, rgba(25,118,210,0.1))';
                }
              }}
              onMouseOut={(e) => {
                e.target.style.backgroundColor = 'transparent';
              }}
            >
              Reenviar código
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  </>
);

export default ModalConfirmEmail; 